import { useEffect, useState } from 'react';
import "./SelectWeekDay.css";
import { regularHours } from '../constants/openHours';
const SelectWeekDay = ({days, onChange}) => {  
  const [daySelected, setDaySelected] = useState([]);

  useEffect(() => {
    console.log(`SelectWeekDay onChange  useEffect ${JSON.stringify(daySelected)}`)
    if(daySelected?.length > 0){
      onChange(daySelected)
    }    
  },[daySelected])

  const handleChange = (item) => {    
    console.log(` handleChange ${item.name}`)
    const findIndex = daySelected.findIndex((x) => {return x.id === item.id})
    let newSelected = [...daySelected];    
    if(findIndex > 0) {
        newSelected.splice(findIndex, 1)        
        const itemRemove = {
          ...item,
          removed: true
        }
        newSelected.push(itemRemove)
      
    }else{
        newSelected.push(item)
    }
    setDaySelected(newSelected)           
  };

  return (
    regularHours?.map((x) => (     
    <div class="weekDays-selector">
        <input type="checkbox" id={`weekday-${x.name}`} class="weekday" onChange={() => {                
                handleChange(x)
            }} />
        <label for={`weekday-${x.name}`}>{x.symbol}</label>
    </div>
  ))) 
};

export default SelectWeekDay;